import { Component, Input } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { RoutesPath } from '@shared/routes-path';
import { Router } from '@angular/router';
import { EventsService } from '@layouts/default/layouts/logged/pages/events/events.service';
import { EventsServicePublic } from '@layouts/default/layouts/guest/pages/events/events.service';

@Component({
  selector: 'app-event-convert-modal',
  templateUrl: './event-convert-to-project-modal.html',
  styleUrls: ['./event-convert-to-project-modal.scss'],
})
export class EventConvertModalComponent extends BaseComponent {
  @Input() eventId: number;
  displayConvertToProjectModal: boolean = false;

  disabled: boolean = false;

  constructor(
    public eventService: EventsService,
    public eventServicePublic: EventsServicePublic,
    public router: Router
  ) {
    super();
  }

  onConvertEventError(error) {
    console.log(error);
    this.disabled = false;
    this.toast.error(this.translate.instant('EVENT.event_error'));
    return;
  }

  convertToProject() {
    const pack = {
      event: this.eventId,
    };

    const urlType = this.eventService.convertToProject({ event_project: pack });
    const convertedToProject = urlType.subscribe((res) => {
      this.toast.success(this.translate.instant('EVENT.converted_to_project'));
      setTimeout(() => {
        this.router.navigate([RoutesPath.default.project_edit + '/' + res.data.id]);
      }, 2000);
    }, this.onConvertEventError.bind(this));
    this.someSubscriptions.add(convertedToProject);
  }
}
